import { render, staticRenderFns } from "./GlobalKeyPressHandler.vue?vue&type=template&id=3d3c6246&"
import script from "./GlobalKeyPressHandler.vue?vue&type=script&lang=ts&"
export * from "./GlobalKeyPressHandler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports